import MediaQuery from 'react-responsive'

import { componentSelector as wordpressComponentSelector } from 'wordpress/selectors'
import { GRID_BREAKPOINT_MD, GRID_BREAKPOINT_SM } from 'shared/breakpoints'

const NavLink = ({ label, type, url, page = '', pageSlug }) =>
    type === 'page' || type === 'page-slug' ? (
        <Link className="indigo-nav-link" to={pageSlug || page}>
            {label}
        </Link>
    ) : (
        <a href={url} target="_blank" rel="noopener noreferrer">
            {label}
        </a>
    )

NavLink.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
}

const PromotionButton = ({ label, page }) => (
    <Link className="nav-btn-promotion" to={page}>
        {label}
    </Link>
)

PromotionButton.propTypes = {
    label: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
}

const NavLeft = ({ content = [] }) => {
    const promotions = content.filter(item => item.layout === 'promotions').shift()
    const links = content.filter(item => item.layout !== 'promotions')

    return (
        <div className="nav-left">
            {promotions && (
                <MediaQuery minWidth={GRID_BREAKPOINT_SM}>
                    <PromotionButton {...promotions} />
                </MediaQuery>
            )}
            <MediaQuery minWidth={GRID_BREAKPOINT_MD}>
                <ul className="horizontal-list">
                    {links.map((item, index) => (
                        <li key={index}>
                            <NavLink {...item} />
                        </li>
                    ))}
                </ul>
            </MediaQuery>
        </div>
    )
}

NavLeft.propTypes = {
    navItems: PropTypes.object,
}

export default connect(wordpressComponentSelector('header'))(NavLeft)
